import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AlertDialog(props) {
  let { showPOAlert, setShowPOAlert } = props;

  const handleClose = (event) => {
    setShowPOAlert({ open: false, agreed: event.target.value });
  };

  return (
    <div>
      <Dialog
        open={showPOAlert.open}
        //onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {showPOAlert.alertDescription}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} value={"true"} autoFocus>
            Yes
          </Button>
          <Button onClick={handleClose} value={"false"}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
